import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'fromCartProductMultiModifiersArray'
})
export class FromCartProducMultiModifiersArrayPipe implements PipeTransform {
  transform(collection: any[]): string {
    const selectedModifiers = [];

    collection?.map((group) => {
      group.modifiers?.forEach((modifier) => {
        if (modifier.selected) {
          const modifierQty = modifier.isMultiSelect
            ? modifier.selectedValue
            : 1;
          for (let index = 0; index < modifierQty; index++) {
            selectedModifiers.push(modifier);
          }
        }
      });
    });
    return selectedModifiers?.length > 0
      ? selectedModifiers.map((x) => '+ ' + x.modifierName.trim()).join(', ')
      : '';
  }
}
